export default __webpack_public_path__ + "static/media/temporary.832c7a02.svg";